import React from 'react';

function BackButton({label, className, onClick}) {
  return (
    <button
      className="ds-btn _link _back -secondary _noVerticalPadding"
      onClick={onClick}
      data-test="back-button"
      data-testid="back-button">
      <i className="materialIcon --small">arrow_backward</i>
    </button>
  );
}

export default BackButton;



// WEBPACK FOOTER //
// ./src/features/shared/components/layouts/BackButton.js